import type { ServiceRegistry } from "@/services/core/service-registry";
import { createContext } from "react";

export interface ServiceContextValue {
  registry: ServiceRegistry;
  servicesInitialized?: boolean;
}

export const ServiceContext = createContext<ServiceContextValue | undefined>(undefined);
